import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab, ControlLabel, FormControl} from "react-bootstrap";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import moment from 'moment'
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import ClientApi from "../../../biletyConfig/biletyApi/ClientService";

export default class SzukajSearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            miejscowoscOd: null,
            miejscowoscDo: null,
            przystankiOd: [],
            przystankiDo: [],
            przystanekOd: null,
            przystanekDo: null,
            data: moment(),
            czas:'06:00',

        };
        this.onChangeMiejscowoscOd = this.onChangeMiejscowoscOd.bind(this)
        this.onChangeMiejscowoscDo = this.onChangeMiejscowoscDo.bind(this)
        this.onChangePrzystanekOd = this.onChangePrzystanekOd.bind(this)
        this.onChangePrzystanekDo = this.onChangePrzystanekDo.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.onChangeCzas = this.onChangeCzas.bind(this)

        this.onClickWyszukaj = this.onClickWyszukaj.bind(this)

        this.pobierzPrzystanki = this.pobierzPrzystanki.bind(this)
    }

    pobierzPrzystanki(miejscowoscOd, miejscowoscDo) {
        let data = {
            "idMiDo": miejscowoscDo.idMi,
            "idMiOd": miejscowoscOd.idMi
        }
        ClientApi.getPrzystankiWObuSamychMiejscowosciach(data).then(function (response) {
            this.setState({
                przystankiOd: response.data[0],
                przystankiDo: response.data[1],
            })
        }.bind(this))
    }

    onChangeMiejscowoscOd(e) {
        this.setState({
            miejscowoscOd: e,
            przystankiOd: [],
            przystankiDo: [],
            przystanekOd: null,
            przystanekDo: null
        })
        if (e !== null && Boolean(this.state.miejscowoscDo)) {
            this.pobierzPrzystanki(e, this.state.miejscowoscDo)
        }
    }

    onChangeMiejscowoscDo(e) {
        this.setState({
            miejscowoscDo: e,
            przystankiOd: [],
            przystankiDo: [],
            przystanekOd: null,
            przystanekDo: null,
        })
        if (e !== null && Boolean(this.state.miejscowoscOd)) {
            this.pobierzPrzystanki(this.state.miejscowoscOd, e)
        }
    }

    onChangePrzystanekOd(e) {
        this.setState({przystanekOd: e})
    }

    onChangePrzystanekDo(e) {
        this.setState({przystanekDo: e})
    }

    onChangeData(e) {
        this.setState({data: e})
    }

    onChangeCzas(e) {
        this.setState({czas: e.target.value})
    }

    onClickWyszukaj() {
        if(
            Boolean(this.state.przystanekDo) &&
            Boolean(this.state.przystanekOd) &&
            Boolean(this.state.czas) &&
            Boolean(this.state.data)
        ){

            let data = {
                "data": DateAndTimeFormat.formatYYYYMMDD(this.state.data),
                "godz": this.state.czas,
                "idPrDo": this.state.przystanekDo.idPr,
                "idPrOd": this.state.przystanekOd.idPr
            }
            this.props.handleClickWyszukaj(data)
        }
        else alert('Nie uzupełniono wszystkich pól!')
    }

    render() {

        return (
            <div>
                <Row>
                    <Col xs={12} lg={5}>
                        <Row>
                            <Col xs={12} lg={6}>
                                <ControlLabel>
                                    Miejscowość od
                                </ControlLabel>
                                <TopSelect onChange={this.onChangeMiejscowoscOd} value={this.state.miejscowoscOd} options={this.props.miejscowosci}
                                           valueKey={'idMi'} labelKey={'nazMi'}/>
                            </Col>
                            <Col xs={12} lg={6}>
                                <ControlLabel>
                                    Miejscowość do
                                </ControlLabel>
                                <TopSelect onChange={this.onChangeMiejscowoscDo} value={this.state.miejscowoscDo} options={this.props.miejscowosci}
                                           valueKey={'idMi'} labelKey={'nazMi'}/>
                            </Col>
                        </Row>
                        <Row style={{marginTop: '15px'}}>
                            <Col xs={12} lg={6}>
                                <ControlLabel>
                                    Przystanek od
                                </ControlLabel>
                                <TopSelect onChange={this.onChangePrzystanekOd} value={this.state.przystanekOd} options={this.state.przystankiOd}
                                           valueKey={'idPr'} labelKey={'nazPr'}
                                           disabled={(!Boolean(this.state.miejscowoscOd) || !Boolean(this.state.miejscowoscDo))}/>
                            </Col>
                            <Col xs={12} lg={6}>
                                <ControlLabel>
                                    Przystanek do
                                </ControlLabel>
                                <TopSelect onChange={this.onChangePrzystanekDo} value={this.state.przystanekDo} options={this.state.przystankiDo}
                                           valueKey={'idPr'} labelKey={'nazPr'}
                                           disabled={(!Boolean(this.state.miejscowoscOd) || !Boolean(this.state.miejscowoscDo))}/>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Row>
                            <Col xs={12} lg={6}>
                                <ControlLabel>Data</ControlLabel>
                                <TopInputDate onChange={this.onChangeData} value={this.state.data} horizontal={true}/>
                            </Col>
                        </Row>
                        <Row style={{marginTop: '15px'}}>
                            <Col xs={12} lg={3}>
                                <ControlLabel>Od godziny</ControlLabel>
                                <FormControl type={'time'} onChange={this.onChangeCzas} defaultValue={'06:00'}/>
                            </Col>
                            <Col xs={12} lg={6}>
                                <div style={{height:'24px'}}></div>
                                <TopButtonAction text={'Wyszukaj rekordy'} iconType={'fa fa-search'} onClick={this.onClickWyszukaj} btnSize={'medium'}/>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/szukaj/components/SzukajSearchbox.js